import { Box, Button, CircularProgress, FormControl, FormControlLabel, Grid, Link, Paper, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { TipoDivisaoPagamento, useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { useMoeda } from "../../../../../core/hooks/useMoeda";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { RadioCard } from "../../../../../core/components/RadioCard";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { ContentDrawer, DividirPadidoDrawer, HeaderDrawer, TipoContent } from "./styles";
import { IProdutoPedido } from "../../../../interface/IProdutoPedido";
import { CardProdutoCarrinhoOperacao } from "../../../../../produtos/components/CardProdutoCarrinhoOperacao";
import { v4 } from "uuid";
import { IPedido } from "../../../../interface/IPedido";
import { useSnackbar } from "../../../../../core/contexts/SnackbarContext";
interface DividirPedidoProps {
    aberto: boolean;
    fechar: () => void;
    produtos: IProdutoPedido[]
    valorTotalPedido: number;
    dividir: (produtos: string[]) => Promise<IPedido> 
}

interface IProdutoPedidoDividir extends IProdutoPedido {
    uuidOriginal: string;
}
 
export const DividirPedido = ({ aberto, fechar, valorTotalPedido, produtos, dividir }: DividirPedidoProps) => {
    const { real } = useMoeda();
    const [produtosSelecionados, setProdutosSelecionados] = useState<IProdutoPedidoDividir[]>([]);
    const [produtosPendentes, setProdutosPendentes] = useState<IProdutoPedidoDividir[]>([]);

    useEffect(() => {
        const novosProdutos: IProdutoPedidoDividir[] = [];

        produtos?.forEach(produto => {
            for (let i = 0; i < (produto.quantidade ?? 1); i++) {
                novosProdutos.push({
                    ...produto,
                    uuid: v4(), // usado apenas para controle visual/seleção
                    uuidOriginal: produto.uuid, // mantém a referência original
                    quantidade: 1
                });
            }
        });        
        
        setProdutosPendentes(novosProdutos)
        setProdutosSelecionados([]);
    }, [produtos])


    const selecionarProduto = (produto: any) => {
        const produtoIndex = produtosSelecionados.findIndex(produtoProcurado => produtoProcurado.uuid == produto.uuid);

        if (produtoIndex !== -1) {
            const novosProdutos = produtosSelecionados;
            novosProdutos.splice(produtoIndex, 1);
            setProdutosSelecionados([...novosProdutos]);
            return;
        }

        setProdutosSelecionados([...produtosSelecionados, produto]);
    }

    const notificar = useSnackbar();

    const handleDividirPedido = async () => {
        const resultado = await dividir(produtosSelecionados.map(p => p.uuidOriginal));
        notificar((
            <>Pedido dividido com sucesso <Link href={`/pedidos/operacao/edicao/${resultado.uuid}`}>{resultado.numeroPedido}</Link></>
        ), { severity: 'info' })
        fechar();
    }

    return (
        <DividirPadidoDrawer
            anchor="bottom"
            open={aberto}
            onClose={fechar}
        >
            <HeaderDrawer>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Dividir pedido
                    </Typography>
                    <Typography variant="h6">
                        {real(valorTotalPedido)}
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Button
                        variant="contained"
                        sx={{
                            width: '200px',
                            height: '45px',
                            marginBottom: '0.5rem'
                        }}
                        disabled={!produtosSelecionados?.length}
                        onClick={handleDividirPedido}
                    >
                        Dividir pedido
                    </Button>
                    <Typography>
                        {produtosSelecionados?.length} selecionado(s)
                    </Typography>
                </Box>
            </HeaderDrawer>
            <ContentDrawer>
                <TipoContent>
                    <Grid
                        container
                        spacing={1}
                        sx={{ marginTop: "1rem" }}
                    >
                        {produtosPendentes.map(produto => {
                            return (
                                <Grid item xs={6} md={2} key={produto.uuid}>
                                    <CardProdutoCarrinhoOperacao
                                        produto={produto}
                                        selecionar={selecionarProduto}
                                        selecionado={produtosSelecionados.find(produtoSelecionado => produtoSelecionado.uuid == produto.uuid) ? true : false}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                </TipoContent>
            </ContentDrawer>
        </DividirPadidoDrawer>
    );
}